import { getAccountStorage } from '@juvare/contact-management/backend/features/accounts';
import { getGroupStorage } from '@juvare/contact-management/backend/features/groups';
// eslint-disable-next-line no-restricted-imports
import { authGroup } from '@juvare/contact-management/backend/features/groups/entities/Group/Callbacks/OnAuth';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { isUuid } from '../../../../utils';
import { searchAlertResponders } from '../../alertServiceClient';
import { createTokenRequest } from '../../utils/createTokenRequest';
import { searchAlertRespondersPageSize } from '../constants';
import { addAlertRespondersToGroupBulkActionType } from './types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const addAlertRespondersToGroup = (config) => defineBulkAction({
    type: addAlertRespondersToGroupBulkActionType,
    onAuthRunSync: (_userContext, { data }) => {
        return data.params.responderCount <= searchAlertRespondersPageSize;
    },
    onAuthBulkAction: (userContext, { data }) => {
        authGroup(userContext.userState, getGroupStorage(userContext).get(data.params.groupId));
        return {
            createTokenUserData: {
                userId: userContext.userState.id,
                displayName: userContext.userState.displayName,
                permissions: {
                    systemPermissions: userContext.userState.systemPermissions,
                    orgPermissions: userContext.userState.orgPermissions,
                },
            },
        };
    },
    onProcessBulkAction: (appContext, { data, isCancelled, updateTotalCount, updateProcessedCount }) => {
        const accountStorage = getAccountStorage(appContext);
        const groupStorage = getGroupStorage(appContext);
        let processedCount = 0;
        let stop = false;
        const processResponders = (externalIds) => {
            const validIds = externalIds.filter((id) => isUuid(id));
            const accounts = accountStorage.list({
                filter: [
                    { column: 'systemStatus', op: '!=', value: 'deleted' },
                    { op: 'in', id: validIds },
                ],
            });
            if (isCancelled()) {
                stop = true;
                return;
            }
            groupStorage.addAccountsToGroup(data.params.groupId, accounts.rows.map((row) => row.id));
            if (isCancelled()) {
                stop = true;
                return;
            }
            processedCount += externalIds.length;
            updateProcessedCount(processedCount);
        };
        if (data.params.externalIds) {
            updateTotalCount(data.params.externalIds.length);
            processResponders(data.params.externalIds);
        }
        else {
            const getRespondersPage = (page) => searchAlertResponders(appContext, createTokenRequest({
                context: appContext,
                userId: data.secureParams.createTokenUserData.userId,
                userPermissions: data.secureParams.createTokenUserData.permissions,
            }), { alertId: data.params.alertId, page: page, size: searchAlertRespondersPageSize }, Object.assign(Object.assign({}, data.params.request), { alertResponderFields: ['externalId'] }));
            let page = 0;
            while (!stop) {
                const responders = getRespondersPage(page);
                if (isCancelled()) {
                    return;
                }
                if (page === 0) {
                    updateTotalCount(responders.totalCount);
                }
                if (responders.items.length > 0) {
                    processResponders(responders.items.map((responder) => responder.externalId));
                }
                if (responders.offset * searchAlertRespondersPageSize + searchAlertRespondersPageSize < responders.totalCount) {
                    ++page;
                }
                else {
                    break;
                }
            }
        }
    },
});
